import { ReactElement } from "react";
import { FaSpinner } from "react-icons/fa";
import "./index.css";
import { Row } from "antd";

const Spinner = ({ isFullWidth }: { isFullWidth?: boolean }): ReactElement => {
  return (
    <Row
      className={`spinner-overlay ${
        !isFullWidth ? "custom-spinner-overlay" : "left-0"
      }`}
    >
      <Row
        className={`spinner-container ${
          !isFullWidth ? "custom-spinner" : "w-full"
        }`}
      >
        <Row className="lds-ripple">
          <FaSpinner className="loading-icon" />
        </Row>
      </Row>
    </Row>
  );
};

export default Spinner;
